export { epic } from './epic'
export { default } from './reducer'



// WEBPACK FOOTER //
// ./src/modules/user/index.js